import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { useMonthOptions } from '../../lib/useMonthOptions';

export const Field = ({ label, children, className = '' }) => (
    <label className={`block ${className}`}><span className="block text-[10px] uppercase tracking-wider text-gray-400 mb-1">{label}</span>{children}</label>
);

export function Pick({ value, onChange, items, placeholder, testId, className = 'h-9 text-[13px]' }) {
    return (
        <Select value={value || undefined} onValueChange={onChange}>
            <SelectTrigger className={className} data-testid={testId}><SelectValue placeholder={placeholder} /></SelectTrigger>
            <SelectContent className="max-h-64">{items.map(([v, l, dis]) => <SelectItem key={v} value={v} disabled={dis}>{l}</SelectItem>)}</SelectContent>
        </Select>
    );
}

export function MonthPick({ value, onChange, testId, disabledMonths = [], note }) {
    const months = useMonthOptions();
    const cur = new Date().toISOString().slice(0, 7);
    const list0 = months.some(m => m.value === cur) ? months : [{ value: cur, label: cur }, ...months];
    const list = value && !list0.some(m => m.value === value) ? [{ value, label: value }, ...list0] : list0;
    return <Pick value={value} onChange={onChange} testId={testId} placeholder="Mois" items={list.map(m => [m.value, `${m.label}${disabledMonths.includes(m.value) ? ` — ${note || 'gelé'}` : ''}`, disabledMonths.includes(m.value)])} />;
}

export const Seg = ({ value, onChange, items, testId }) => (
    <div className="inline-flex rounded-lg border border-gray-200 p-0.5 bg-gray-50" data-testid={testId}>
        {items.map(([v, l]) => (
            <button key={v} type="button" onClick={() => onChange(v)} data-testid={`${testId}-${v}`}
                className={`px-2.5 py-1 rounded-md text-[12px] font-medium transition-colors ${value === v ? 'bg-white shadow-sm text-gray-900' : 'text-gray-500'}`}>{l}</button>
        ))}
    </div>
);
